export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-Medium-1.fc3c323b.ttf";